// extracted by mini-css-extract-plugin
module.exports = {"container":"Confirmation_container_1jrU7","grayContent":"Confirmation_grayContent_8D9sO","footer":"Confirmation_footer_27wQ2","button":"Confirmation_button_H1GAm"};